module.exports = __webpack_public_path__ + "img/mp2.8c6520aa.png";